import { cn } from '@commenda/utils';
import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment } from 'react';

export function VerticalDrawer({
  children,
  isOpen,
  close,
  className = '',
  panelClassName = '',
}: {
  children: React.ReactNode;
  isOpen: boolean;
  close: () => void;
  className?: string;
  panelClassName?: string;
}) {
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-30" onClose={close}>
        <div className="fixed inset-0" />

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div
              className={cn(
                'pointer-events-none fixed inset-y-0 right-0 flex max-w-full',
                className
              )}
            >
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-y-full"
                enterTo="translate-y-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-y-0"
                leaveTo="translate-y-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-full">
                  <div
                    className={cn(
                      'flex h-full flex-col overflow-y-auto bg-white shadow-xl',
                      panelClassName
                    )}
                  >
                    {children}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
